var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.107 8.143H.68A.679.679 0 0 0 0 8.82v8.143C0 18.09.911 19 2.036 19h4.071a.679.679 0 0 0 .679-.679v-9.5a.679.679 0 0 0-.679-.678Zm-.678 9.5H2.036a.679.679 0 0 1-.679-.679V9.5H5.43v8.143ZM16.964 0H2.036A2.036 2.036 0 0 0 0 2.036v4.071c0 .375.304.679.679.679H18.32A.679.679 0 0 0 19 6.107V2.036A2.036 2.036 0 0 0 16.964 0Zm.679 5.429H1.357V2.036c0-.375.304-.679.679-.679h14.928c.375 0 .679.304.679.679v3.393Zm.678 2.714h-9.5a.679.679 0 0 0-.678.678v9.5c0 .375.304.679.678.679h8.143A2.036 2.036 0 0 0 19 16.964V8.821a.679.679 0 0 0-.679-.678Zm-.678 8.821a.679.679 0 0 1-.679.679H9.5V9.5h8.143v7.464Z",
    fill: "#264D6D",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityDashboard);
export default __webpack_public_path__ + "static/media/activity-dashboard.132abc108ffc8d29d9fca24484b8e6fe.svg";
export { ForwardRef as ReactComponent };